import { SVGProps, Ref, forwardRef } from 'react';

export const CheckmarkOutlinedCircledSize16Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <g>
                    <path d="M11.849 6 11 5.151l-4 4-2-2L4.152 8 7 10.848z" fill="currentColor" />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M.667 8C.667 4.333 2.5.667 8 .667S15.333 4.333 15.333 8 13.5 15.333 8 15.333.667 11.667.667 8m1.2 0c0-1.655.416-3.182 1.326-4.273C4.07 2.673 5.539 1.867 8 1.867s3.93.806 4.807 1.86c.91 1.091 1.326 2.618 1.326 4.273s-.416 3.182-1.326 4.273c-.877 1.054-2.346 1.86-4.807 1.86s-3.93-.806-4.807-1.86C2.283 11.182 1.867 9.655 1.867 8"
                        fill="currentColor"
                    />
                </g>
            </g>
        </svg>
    )
);
CheckmarkOutlinedCircledSize16Glyph.displayName = 'CheckmarkOutlinedCircledSize16Glyph';
